module.exports = __webpack_public_path__ + "img/pic_subject_science.64e2216b.png";